import { tv } from 'tailwind-variants';
import RemixIcon from 'helpers/RemixIcon/RemixIcon';

export type SearchFacetTagsProps = {
  selectedFacets: Array<{
    label: string;
    name: string;
    value: Array<{
      id: string;
      text: string;
      count?: number;
    }>;
  }>;
  onRemoveTag: (facetName: string, valueId: string, valueText: string) => void;
  onClearAll: () => void;
  showClearAll?: boolean;
  className?: string;
};

const SearchFacetTags = ({ selectedFacets, onRemoveTag }: SearchFacetTagsProps) => {
  const { base, tag, tagText, removeButton } = TAILWIND_VARIANTS();

  // Flatten all selected facet values into individual tags
  const allTags = selectedFacets.flatMap((facet) =>
    facet.value.map((value) => ({
      facetName: facet.name,
      facetLabel: facet.label,
      valueId: value.id,
      valueText: value.text,
    }))
  );

  if (allTags.length === 0) {
    return <></>;
  }

  return (
    <div className={base()}>
      <div className="flex flex-wrap gap-2 items-center">
        {allTags.map((tagItem, index) => (
          <div key={`${tagItem.facetName}-${tagItem.valueId}-${index}`} className={tag()}>
            <span className={tagText()}>{tagItem.valueText}</span>
            <button
              type="button"
              onClick={() => onRemoveTag(tagItem.facetName, tagItem.valueId, tagItem.valueText)}
              className={removeButton()}
              aria-label={`Remove ${tagItem.facetLabel} filter: ${tagItem.valueText}`}
            >
              <RemixIcon name="ri-close-line" size="sm" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchFacetTags;

const TAILWIND_VARIANTS = tv({
  slots: {
    base: ['w-full', 'flex', 'flex-row', 'flex-wrap', 'gap-spacing-spacing-8'],
    tag: [
      'w-fit',
      'flex',
      'flex-row',
      'flex-nowrap',
      'items-center',
      'gap-spacing-spacing-2',
      'py-spacing-spacing-2',
      'px-spacing-spacing-4',
      'bg-color-core-color-4-skyblue-lightTint',
      'border',
      'border-color-core-color-4-skyblue-darkTint',
      'rounded-border-radius-radius-1',
    ],
    tagText: [
      'font-typography-font-family-body',
      'text-p-color-text',
      'text-typography-font-size-body-xSmall',
    ],
    removeButton: ['w-4', 'h-4', 'text-p-color-icon', 'flex', 'items-center', 'justify-center'],
  },
});
